import {
    ALLOW_OUT_OF_STOCK_EXCHANGE_OPTION,
    CREDIT_AMOUNT_TYPE,
    INSTANT_REFUND_PROVIDER,
    REFUND_BY,
    RESOLUTION_ID,
    RESOLUTION_TYPE,
    RETURN_ALTERNATIVE,
    VOUCHER_TYPE
} from '../pages/resolutions/constants';
import { IShippingSettings } from '../pages/resolutions/stores/shipping-settings-store';

export enum RESOLUTION_CATEGORY {
    returngo_resolutions = 'returngo_resolutions',
    standard_resolutions = 'standard_resolutions',
    exchange_resolutions = 'exchange_resolutions',
    cancel_order_resolutions = 'cancel_order_resolutions',
    other_resolutions = 'other_resolutions',
}

export interface IResolutionCategory {
    category: RESOLUTION_CATEGORY, list: IResolution[],
};

export interface IResolution {
    id: number,

    resolution_id: RESOLUTION_ID,
    resolution_type: RESOLUTION_TYPE,
    internal_name: string,
    name: string,
    description: string,
    exclude_by_gateway: boolean,

    range_from: number,
    range_to: number,
    round_offer: number,
    cash_protection: number,
    voucher_type: VOUCHER_TYPE,

    credit_amount_type: CREDIT_AMOUNT_TYPE,
    is_return_go: boolean,
    is_percentage: boolean,
    modify_credit_amount: number | undefined | null,

    present_more_expensive: boolean,
    indicate_less_expensive: boolean,
    refund_by: REFUND_BY,
    size_chart_url: string,
    default_shipping_line_title: string,
    release_exchange_type: number,
    allow_out_of_stock_exchanging: ALLOW_OUT_OF_STOCK_EXCHANGE_OPTION,

    allow_auto_refund: boolean,

    image: number,
    is_hidden: boolean,
    size_option_name: string,

    instant_refund_provider: INSTANT_REFUND_PROVIDER | null,

    minimum_available_stock_threshold: number,
    shipping_setting_id: number,
    resolution_shipping_setting?: IShippingSettings,

    _deleted: boolean,
}

export type IDefaultOfferRanges = {
    [key in RETURN_ALTERNATIVE]: [number, number]
};